/* ===========================================================================
   REVIVE WEB V2. JS local de las superficies de tienda.

   Deliberadamente pequeño y sin dependencias. La lógica de compra (variantes,
   añadir al carrito, filtros) es de Dawn y no se toca aquí. Esto solo se ocupa
   de la presentación: aparición al hacer scroll, indicador de galería móvil y
   barra de compra fija. Un único IntersectionObserver compartido para revelar.

   Respeta prefers-reduced-motion: si el usuario lo pide, no observa nada y todo
   queda visible y operativo desde el inicio.
   =========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Aparición al entrar en viewport (compartida con la home) ---------- */
  function revelar(raiz) {
    var nodos = (raiz || document).querySelectorAll('.rv-aparece:not([data-rv-visible])');
    if (reduce || !('IntersectionObserver' in window)) {
      nodos.forEach(function (n) { n.setAttribute('data-rv-visible', 'true'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-rv-visible', 'true');
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodos.forEach(function (n) { obs.observe(n); });
  }

  /* La rejilla de colección/búsqueda no anima (regla de DESIGN.md): las tarjetas
     se renderizan estables desde el primer frame y el filtrado por AJAX no espera
     ni re-anima nada. Por eso no se observa #ProductGridContainer para revelar. */

  /* ---- Galería de producto: indicador de posición en móvil ---------------- */
  document.querySelectorAll('.rv-galeria').forEach(function (galeria) {
    var pista = galeria.querySelector('.rv-galeria__pista');
    var puntos = galeria.querySelectorAll('.rv-galeria__punto');
    if (!pista || !puntos.length) return;
    var slides = pista.querySelectorAll('.rv-galeria__slide');
    if (!('IntersectionObserver' in window)) return;
    var visor = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          var i = Array.prototype.indexOf.call(slides, e.target);
          puntos.forEach(function (p, k) { p.setAttribute('data-rv-activo', k === i ? 'true' : 'false'); });
        }
      });
    }, { root: pista, threshold: 0.6 });
    slides.forEach(function (s) { visor.observe(s); });
  });

  /* ---- Barra de compra fija en móvil -------------------------------------- */
  var barra = document.querySelector('.rv-barra-compra');
  var ancla = document.querySelector('[data-rv-ancla-compra]');
  if (barra && ancla && 'IntersectionObserver' in window) {
    var centinela = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        // Visible mientras el bloque de compra principal NO está en pantalla
        barra.setAttribute('data-rv-visible', e.isIntersecting ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    centinela.observe(ancla);
  }

  /* ---- Botón de compra: destello de éxito "AÑADIDO" ----------------------
     Dawn ya gestiona loading (spinner + aria-disabled) y evita el doble envío
     (ignora el submit si aria-disabled). Aquí solo se añade el feedback de
     éxito en el propio botón, observando cuándo termina el estado .loading sin
     error. No sustituye al aviso de carrito: lo complementa. */
  document.querySelectorAll('.rv-compra .product-form__submit').forEach(function (btn) {
    var span = btn.querySelector('span');
    if (!span || !('MutationObserver' in window)) return;
    var form = btn.closest('product-form');
    var okTexto = (btn.getAttribute('data-rv-ok-texto') || 'AÑADIDO');
    var estabaCargando = false;
    var temporizador = null;

    new MutationObserver(function () {
      var cargando = btn.classList.contains('loading');
      if (cargando) { estabaCargando = true; return; }
      if (!estabaCargando) return;
      estabaCargando = false;
      // ¿Hubo error? El envoltorio de error deja de estar oculto.
      var errWrap = form && form.querySelector('.product-form__error-message-wrapper');
      var hayError = errWrap && !errWrap.hasAttribute('hidden');
      if (hayError) return;
      // Éxito: destello breve en el botón
      var original = span.textContent;
      span.textContent = okTexto;
      btn.setAttribute('data-rv-ok', 'true');
      if (temporizador) clearTimeout(temporizador);
      temporizador = setTimeout(function () {
        span.textContent = original;
        btn.removeAttribute('data-rv-ok');
      }, 1600);
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  });

  revelar(document);
})();
